export default class CheckboxController {
  constructor($scope, $attrs, $element, elementService) {
    'ngInject'
    this._$scope = $scope
    this._$attrs = $attrs
    this._$element = $element
    this._elementService = elementService
  }

  $onInit() {
    // Re-define $render
    this.ngModelCtrl.$render = () =>
      this.ngModelCtrl.$setViewValue(this.ngModelCtrl.$viewValue)

    // Set a watch to run render if any changes to the model occur outside of the component
    this._$scope.$watch(
      () => this.ngModelCtrl.$viewValue,
      () => this.ngModelCtrl.$render(),
      true
    )
  }

  $postLink() {
    const mixed = this._$attrs.mixed
    const classes = this._elementService.getClasses(this._$element)

    classes.push('vd-checkbox')

    if (mixed) {
      classes.push('vd-checkbox--mixed')
    }

    this._$attrs.$set('class', classes.join(' '))
  }
}
